import { useState } from 'react';
import { observer } from 'mobx-react';

import { PayHeader } from '../PayHeader';
import { Tabs } from '../Tabs';
import { PayFormRoot } from './PayForm.Root';
import { FormFull } from './Full/Form.Full';
import { FormMin } from './Min/Form.Min';
import { FormAny } from './Any/Form.Any';
import { Store } from '../../stores';

const FormComponent = () => {
  const store = Store.use();
  const tabs = [
    {
      id: 'full',
      text: 'Полное погашение',
    },
    {
      id: 'partial',
      text: 'Частичное погашение',
    },
  ];

  let expiredAmount: any = (store?.amountExpired || 0) * 0.01;
  expiredAmount = expiredAmount.toFixed(2);

  let amount: any = (store.amountFull || 0) * 0.01;
  amount = amount.toFixed(2);

  const subtitle = store.isExpired
    ? `Оплатите ${expiredAmount} ₽ для погашения суммы задолженности или ${amount} ₽ для полного погашения займа `
    : 'Для оплаты займа по частям выберите «Частичное погашение», для оплаты всей суммы сразу — «Полное погашение»';

  const [activeTab, setActiveTab] = useState(
    !store.isHideFullPay ? 'full' : 'partial',
  );

  return (
    <PayFormRoot>
      <PayHeader title="Оплата займа" subtitle={subtitle} />
      {!store.isExpired && !store.isHideFullPay && (
        <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
      )}
      {activeTab === 'full' && !store.isExpired && !store.isHideFullPay ? (
        <FormFull />
      ) : null}
      {activeTab === 'partial' && !store.isExpired && <FormMin />}
      {store.isExpired && <FormAny />}
    </PayFormRoot>
  );
};

export const PayForm = observer(FormComponent);
